import { render, staticRenderFns } from "./duogelink.vue?vue&type=template&id=d2e23b6e&scoped=true"
import script from "./duogelink.vue?vue&type=script&lang=js"
export * from "./duogelink.vue?vue&type=script&lang=js"
import style0 from "./duogelink.vue?vue&type=style&index=0&id=d2e23b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e23b6e",
  null
  
)

export default component.exports